import React from "react"

import { PropertyList } from "shared/ui/property-list/PropertyList"

import { useProductConfigurationAttributesContext } from "./ProductConfigurationAttributesContext"

export const ProductConfigurationAttributesContent = React.memo(() => {
  const { productInformation, isLoading } =
    useProductConfigurationAttributesContext()

  const attributes = React.useMemo(
    () => productInformation?.attributes ?? [],
    [productInformation?.attributes]
  )

  return (
    <PropertyList
      className="product-page__attributes-list"
      list={attributes}
      isLoading={isLoading}
    />
  )
})

ProductConfigurationAttributesContent.displayName =
  "ProductConfigurationAttributes.Content"
